<script setup lang="ts">
import type { ComboboxRootEmits, ComboboxRootProps } from 'reka-ui';
import { ChevronDown } from '@lucide/vue';
import { ComboboxAnchor, ComboboxInput, ComboboxPortal, ComboboxRoot, ComboboxTrigger, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

interface Props extends ComboboxRootProps {
    placeholder?: string;
    // reka-ui moved searchTerm/displayValue from ComboboxRoot to ComboboxInput;
    // accept them here to keep the wrapper's API stable and bind them on the input.
    searchTerm?: string;
    displayValue?: (val: any) => string;
}
interface Emits extends ComboboxRootEmits {
    'submit': [];
    'update:searchTerm': [value: string];
}

const props = defineProps<Props>();
const emits = defineEmits<Emits>();

const rootProps = computed(() => {
    const { placeholder: _placeholder, searchTerm: _searchTerm, displayValue: _displayValue, ...rest } = props;

    return rest;
});

const forwarded = useForwardPropsEmits(rootProps, emits);
</script>

<template>
    <combobox-root
        v-bind="forwarded"
        ignore-filter
        class="relative"
    >
        <combobox-anchor class="w-full inline-flex items-center justify-between border border-gray-900 rounded-sm px-[15px] text-[13px] leading-none h-[35px] gap-[5px] text-green-700 data-placeholder:text-green-600 outline-hidden">
            <combobox-input
                :model-value="searchTerm"
                :display-value="displayValue"
                class="bg-transparent! outline-hidden w-full text-gray-900 h-full selection:bg-green-700 placeholder-gray-700"
                :placeholder="placeholder"
                @update:model-value="emits('update:searchTerm', $event as string)"
                @keyup.enter="emits('submit')"
            />
            <combobox-trigger>
                <chevron-down class="h-4 w-4 text-gray-900" />
            </combobox-trigger>
        </combobox-anchor>
        <combobox-portal>
            <slot />
        </combobox-portal>
    </combobox-root>
</template>
